import { Button, Pagination, Space, Table, Tooltip } from "antd";
import React from "react";
import { CONSTANT } from "../../../../config/Constant";
import { PaginationProps } from "antd/lib/pagination";
import { ColumnsType } from "antd/es/table";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

interface DataType {
  index: number;
  _id: string;
  code: string;
  code_name: string;
  code_value: string;
  description: string;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
    handleEditModal,
    handleDeleteRequest,
  } = props;

  const codesData: DataType[] = listData?.map((item, index) => ({
    key: index.toString(),
    index: item.index,
    _id: item._id,
    code: item.code,
    code_name: item.code_name,
    code_value: item?.code_value,
    description: item.description,
    created_date: item?.created_date,
  }));
  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "index",
      key: "index",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.index - b.index,
      render: (_, record) => {
        return record.index;
      },
    },
    {
      title: "Code",
      key: "code",
      dataIndex: "code",
      width: 120,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.code.localeCompare(b.code),
    },
    {
      title: "Code Name",
      key: "code_name",
      dataIndex: "code_name",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.code_name.localeCompare(b.code_name),
    },
    {
      title: "Code Value",
      key: "code_value",
      dataIndex: "code_value",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.code_value.localeCompare(b.code_value),
    },
    {
      title: "Description",
      key: "description",
      dataIndex: "description",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.description.localeCompare(b.description),
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 150,
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tooltip title={"Edit User"}>
              <Button
                type="default"
                icon={<EditOutlined />}
                className="EditBtn iconBtn"
                onClick={() => {
                  handleEditModal(record);
                }}
              />
            </Tooltip>
            <Tooltip title={"Delete User"}>
              <Button
                onClick={() => {
                  handleDeleteRequest(record);
                }}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };
  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={codesData}
          columns={columns}
          pagination={false}
          loading={tableloading}
        />
        <div className="text-center mt-20 mb-30">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.current}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size}
            // showSizeChanger={totalData ? true : false}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>
    </>
  );
};
export default ListTable;
